<template>
  <div class="cardlist">
    <div class="cardlist-title">
      <div class="cardlist-title-text">选择支付方式</div>
      <div
        class="cardlist-title-close"
        @click="$eb.$emit('showCardList', false)"
      ></div>
    </div>
    <div class="cardlist-body">
      <div v-if="hint" class="cardlist-body-hint">
        <span>{{ hint }}</span>
      </div>
      <div class="cardlist-body-list">
        <div
          v-for="(item, index) in cardinfo"
          :key="index"
          class="cardlist-body-list-item"
          @click="changeCard(index)"
        >
          <Card :cardinfo="item"></Card>
          <template v-if="item.bankcardId !== '1'">
            <div
              v-if="!cardList[index].isSign"
              class="cardlist-body-list-item-check"
            >
              去完善
              <div class="cardlist-body-list-item-check-icon"></div>
            </div>
            <div
              v-else-if="cardList[index].isDefault && cardList[index].isEnable"
              class="cardlist-body-list-item-icon"
            ></div>
          </template>
          <div
            v-if="index !== cardinfo.length - 1"
            class="cardlist-body-list-item-split"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from './card'
export default {
  name: 'CardList',
  components: {
    Card,
  },
  props: {
    cardList: {
      type: Array,
      default: () => [],
    },
    hint: {
      type: String,
      default: '',
    },
    pageActionType: {
      type: Number,
      default: 0,
    },
    brightness: {
      type: Number,
      default: 0.8,
    },
  },
  computed: {
    cardinfo() {
      return this.cardList.map((p) => {
        let labelInfo = ''
        if (p.bankcardId === '1') {
          labelInfo = '添加银行卡，扫码后直接付款'
        } else if ([4, 6].includes(this.pageActionType)) {
          labelInfo = p.bankcardDesc
        } else {
          labelInfo = p?.promotion?.labels
        }
        // bankcardId为1时是添加银行卡，-5时默认括号内文字为尝鲜特权
        let text =
          p.bankcardId === '1'
            ? p.bankcardName
            : `${p.bankcardName}${
                p.bankcardNo
                  ? `(${p.bankcardNo})`
                  : p.bankcardId === '-5'
                  ? '(尝鲜特权)'
                  : ''
              }`
        return {
          icon:
            p.bankcardId === '1'
              ? '//p1.meituan.net/scarlett/9a8be4b164718b64260823ac6ae24e00526.png'
              : p.isEnable
              ? p.bankLogo
              : p.bankGreyLogo,
          text,
          labelInfo,
          bankcardId: p.bankcardId,
        }
      })
    },
  },
  mounted() {
    this.$lx.switchPayTypeModuleMV()
    this.cardList.forEach((p) => {
      if (p.bankcardId === '1') {
        this.$lx.addBankMV()
      } else {
        this.$lx.switchPayTypeMV({
          bank_name: p.bankcardName,
          bank_type_id: p.bankcardId,
          promotion: p?.promotion?.promotionDetails || [],
        })
      }
    })
  },
  methods: {
    changeCard(index) {
      const item = this.cardList[index]
      let url
      if (item.bankcardId !== '1') {
        this.$lx.switchPayTypeMC({
          bank_name: item.bankcardName,
          bank_type_id: item.bankcardId,
          promotion: item?.promotion?.promotionDetails || [],
        })
      }
      // 添加卡片，跳转绑卡页面
      if (item.bankcardId === '1') {
        this.$lx.addBankMC()
        this.$eb.$on('closeCardList')
        url = `${process.env.VUE_APP_BIND_CARD_URL ||
          'https://npay.meituan.com/portal/bindcard/bindcard.html?merchant_no=11000004918439&callback_type=close_webview&ext_dim_stat_entry=payment_code&_mtcq=0'}&ext_dim_stat_custom=%7B%22entry%22:%22quickpass_qrcode%22%7D#/`
        this.$bridge.openPage(url)
        return
      }
      // 银行卡信息不完善，跳转完善银行卡信息页面
      if (!item.isSign) {
        this.$eb.$on('closeCardList')
        url = `${process.env.VUE_APP_BIND_CARD_URL ||
          'https://npay.meituan.com/portal/bindcard/bindcard.html?merchant_no=11000004918439&callback_type=close_webview&ext_dim_stat_entry=payment_code&_mtcq=0'}&bank_card_id=${
          item.bankcardId
        }`
        this.$bridge.openPage(url)
        return
      }
      // 银行卡被禁用，点击不做处理
      if (!item.isEnable) {
        return
      }
      this.$eb.$emit('changeCard', index)
    },
  },
}
</script>
<style lang="less">
@import '../assets/variable.less';
.cardlist {
  .flex-column-center();
  z-index: 13;
  position: fixed;
  bottom: 0;
  left: 0;
  height: 466px;
  width: 100%;
  border-radius: 12px 12px 0 0;
  background: #ffffff;
  &-title {
    .flex-center(center);
    z-index: 14px;
    position: absolute;
    top: 0;
    left: 0;
    height: 66px;
    width: 100%;
    &-text {
      font-size: 18px;
      line-height: 66px;
      font-family: PingFangSC-Semibold;
      color: rgba(0, 0, 0, 0.9);
      text-align: center;
    }
    &-close {
      .size(20px);
      .bg-img(
        url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAplJREFUaAXtmkFuAjEMRRnUq7TXQNyBLuiqG1btccqKDSu6KHdAXKO9SgX1RzPIQCbjJLaFqkSCCZnE/s9ORGaU0aiWGoEagRqBGoEagRqBGoF7jMB+v3/E51605ehppOJ3u90H9X1D/6Zp1sfjcTGdTn+l4zX7kZYH0rAiDa+t3SVpeZf4EAEjkofD4ZsbJIdf5PDFG7qF3ZDvZ65nPB4/TSaTH94Wqo9DjZI2OCToDQRI+mv06YNNsS0CRuQwja8Ne0LHYKFNkl3oFwGjI8EtMI1R58UDegAWS2vBNcXqojXcGRA4Vl/T2j6TgAGuLaALZuhq4SsZ2AvaAhbas4Ctoa1gi4CtoC1hi4G1oa1hVYC1oD1g1YBLob1gVYFzoT1h1YFTob1hTYCl0Cfn9PCBrSnqvGALS+3quzb4yP4f5gJD9YHsbQkIw2bXYy1h4csMGMZj0Lh/Xaxh4c8UGA6k0B6wLsAM+pOm8c0Uxn0qW/rMPd6eiJ+HT7IKvto1G7RA2Q22WzSaA3dTmsT3ZRcvF2YE7fK6yDS0HSwB3fz1hLLnsY7NMjwAuyU4rNuLgsBYZ9oEOAaLLBLlnODmbd0VWn1KD8ES6HkHldL3IioFP1SBcwByxhTw6m08SoSXjE2FV8mwhmANGxL4YmBNoZq2+uCLgC0EWtjk8NnAlsIsbWcBWwrqsmHlIxnYSkgHyq8WvpKALQRwwFBd26cYWNtxCK6vTdO3eC9N+16cqbh56sF+mG8X+0SXtOPFAHxE9t4rqX1RhkNnPODAA5aDxDJtfsbDGxbgsUzzwMTqoindnp9YdoYIFseWzk89XbvHlUGvmb+l9IwHGzNczTkINmw1v8e96cknqSNrBGoEagRqBGoEagT+ZQT+AEJoIildEfrAAAAAAElFTkSuQmCC)
      );
      position: absolute;
      top: 24px;
      right: 19px;
    }
  }
  &-body {
    margin-top: 66px;
    .flex-column-center();
    width: 100%;
    height: 100%;
    overscroll-behavior: contain;
    overflow: auto;
    &-hint {
      .flex-center(center);
      width: 100%;
      min-height: 40px;
      background: rgba(255, 74, 74, 0.1);
      padding: 13px 15px;
      > span {
        .font-area(14px);
        display: inline-block;
        font-family: PingFangSC-Regular;
        color: #ff4a4a;
        letter-spacing: 0;
        text-align: left;
      }
    }
    &-list {
      .flex-column-center();
      width: 100%;
      &-item {
        .flex-center(space-between);
        width: 100%;
        padding: 21px 15px;
        min-height: 80px;
        &-icon {
          .size(12px);
          .bg-img(
            url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAAAXNSR0IArs4c6QAABCVJREFUWAntmF+IVVUUh3/7zmgmSIbYi4UvIj71kA/hQ4zCEIH2YqalEzkSSChjcxVRmAmUfBnUogxFEickshCF/hBE5oMgRNpDhfZU6IhEglhCOZR39+3NnOHMueuce+fOzL2Ccx5m773WOnt/e62119l3pOnnAfWAux/27T9Vm4a0D5aNkcfpuB5Xn1urewlfe9JpaTuko95r0yiD1y53PY52J7JS0mlV6/drwxjIBMSrO+mGtqWg/qAWwXA4DZTXbxkoeTlTFZ300pwcuA/T8paB6roGgFyahkn6zukXzdfeZBzalpx6f0CryMvP0yBJH6C7atfT7g39mMhC23SPkpcL5DWYhhjTdypnIYO+qaCxXnp9RMjnjYEbGeDN0267fbiaCkpR7yfkHTmQVzVbr1m6IGtajhLyDkJ+FtC2LAwQ/0HSgTcvZHXJuCke9YcIdQi5ATkC0l8EGWyaAqphDQK5IPFOusWb32i7BtIyqz/loIS8F8hV1uJA/qGH9Qp1s2Lp07IpzVG+46GgX+CUz0wvGvrAefLyOVfW11mdNZ4yj/pjfBpd/ERWQY6ADNQLGeynDFS3dYSQh0tH1UMYv9NT6qtSFAjag45PWheB6I52bRp0vTpR8E5NFfNtAnK9ZQjknxSol9wKStI4Hkeyb/UVvZd+h8necjvUn5bV2ycvlxDyS4DOtt5xbXoRR5yydEWyEuetnDUg+fvwysasvNbYH9csbD7JhZSONAIZ1i2x+0dyAI76t7U8R2eLb+kgm3zSUhKln1mtyimWrSULh+kzS4FXZvDT6jSeXWzpszI2tZp3Xs/Kw5hS9DcFah2n/B9LX4+sBM5OdvubZYx3HkX+ZfwEWgYjMvQLSaFjuSZOPa5Hl3P1dShKTHCTU7iSXd+27PHSIj6BZ+JPB8PAn+Oae1cfYzfXUJNZOokn8zdhvWTIYh0lwa+gW8OkZskA4hmuaPZiP2gvnl9mzB1C/ish32zpxisbLfjcXs7yspljYVJguyhlb6YXIC87Ge9Ky5I+kP/GetmjvxLZRNpR0DAJtfMDFsi9yVBv91AnXw62/rAe47CdYAMEwnicdvOT4ntD05CoapG48AGdIpyrrRnZyDBfsU7wwm39WdNG+oqrW8h7ppmcZ4xHw5Rx8jnx6nXRWgK4h4D8tgDyBnn56mRCBo4q0CB0m6l7s/Q8iw2FcfYBckZWFsaEp8KfrlhJLIMJyEzQuOgW/c6iK1n8Tt3zO+3jUJ6r234chrmgEbasnzi56/DsvVpzYnNeT2hPLbtG9YWgEbaXgyFtK1oAyFvoN6T/n1lk34iuJmiYlHC+D8y7BQt0Y2Pmc8E741LVBRpnLKsX2C+ysyN7B0jzYpO1nci4blCAKuTgC7T7OWA3aK+5EpfrcuNXt4mAT7/7wHjgf1PABuTQiEEpAAAAAElFTkSuQmCC)
          );
        }
        &-check {
          .flex-center(center);
          .font-area(14px);
          font-family: PingFangSC-Regular;
          color: #666666;
          letter-spacing: 0;
          text-align: left;
          &-icon {
            height: 8px;
            width: 5px;
            margin-left: 6px;
            .bg-img(
              url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAYCAYAAAAlBadpAAAAAXNSR0IArs4c6QAAANdJREFUOBGd1EEOgjAQBVCmHqE7l7RbT+IdXKB74iX0BK4kLjyEnqbdeY46Q2gDoTQzbUIIybzfAdJprLVXY8yvbdt7CAEawQKCiPaTeTnnLgAQOBkK4XtW2GHYwO0AqBDBEwPOsxBWB+M71gakDzQFDLh7x+0gYQLSgAWWBqywJCCLuQGbmBNQxIWAo/f+o6igdhVx4dd9acPNtgswHZws5sDszly4whK4wFKYcA0ccS0krHCK3PDOPsOE4lI47E7xAe+s8RPrd1prmpQHvB44OXvu5KSAP0VZv3QOiYRzAAAAAElFTkSuQmCC)
            );
          }
        }
        &-split {
          position: absolute;
          height: 1px;
          width: 333px;
          transform: scaleY(0.5);
          background: #e5e5e5;
          right: 0;
          bottom: 0;
        }
      }
    }
  }
}
</style>
